import { Box, makeStyles } from "@material-ui/core";
import StarOutlineOutlinedIcon from "@material-ui/icons/StarOutlineOutlined";
import { useMemo, useState } from "react";
import CssGroupButton from "src/components/Button/CssGroupButton";
import SearchTextField from "src/components/TextField/SearchTextField";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { THEME_MODE } from "src/config/constants";
import { useTokenAnalysisSelector } from "src/context/tokenAnalysisContext";
import useSearchData from "src/hooks/useSearchData";
import { getFavoriteTokens } from "src/services/favoriteToken";
import CategoryButton from "./CategoryButton";
import RankingTable from "./RankingTable";

const useStyle = makeStyles((theme) => ({
  root: {
    border: theme.palette.type === THEME_MODE.DARK ? "1px solid #263343" : "1px solid #DEDEDE",
    background: "transparent",
    borderRadius: "6px",
    overflow: "hidden",
  },
  but: {
    color: theme.palette.type === THEME_MODE.DARK ? "#FFFFFF" : "#566474",
    border: "none",
    [theme.breakpoints.only("xs")]: {
      width: "50%",
    },
  },
  activeBut: {
    color: "#FFFFFF",
    background: "#408CEC",
    "&:hover": {
      background: "#408CEC",
    },
  },
  box: {
    display: "flex",
    alignItems: "center",
    padding: "0.5rem",
    [theme.breakpoints.only("xs")]: {
      flexDirection: "column",
      width: "100%",
    },
  },
  box1: {
    display: "flex",
    [theme.breakpoints.only("xs")]: {
      flexDirection: "column",
      width: "100%",
    },
  },
  category: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: "1rem",
    },
    [theme.breakpoints.only("xs")]: {
      marginTop: "0.5rem",
      marginBottom: "0.5rem",
    },
  },
  search: {
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
  },
}));

const searchCategories = (element, index, searchText) => {
  return element.categories.includes(searchText);
};

const searchToken = (element, index, searchText) => {
  const rawSearchText = searchText.toString().toLowerCase();
  const symbolCheck = element.symbol.toString().toLowerCase().includes(rawSearchText);
  let nameCheck = false;
  if (element?.name) nameCheck = element.name.toString().toLowerCase().includes(rawSearchText);
  return symbolCheck || nameCheck;
};

export default function TokenScoreRanking() {
  const cls = useStyle();
  const [searchText, setSearchText] = useState("");

  const [category, setCategory] = useState(null);
  const [type, setType] = useState("all");

  const tokens = useTokenAnalysisSelector((state) => state.tokens);
  const tokenButFilter = useMemo(() => {
    if (type === "all") return tokens;
    else {
      const favoriteTokens = getFavoriteTokens();
      return tokens.filter((element) => {
        return favoriteTokens.includes(element.token_id);
      });
    }
  }, [type, tokens]);

  const filterTokens = useSearchData(tokenButFilter, category, searchCategories);
  const searchTokens = useSearchData(filterTokens, searchText, searchToken);

  return (
    <PaperWrapper title="Token Score Ranking" style={{ marginTop: "1.5rem" }} paperProps={{ style: { padding: 0 } }}>
      <Box className={cls.box} justifyContent="space-between">
        <Box className={cls.box1}>
          <CssGroupButton
            config={[
              { label: "All", onClick: () => setType("all") },
              {
                label: (
                  <>
                    <StarOutlineOutlinedIcon fontSize="small" />
                    Favorite
                  </>
                ),
                onClick: () => setType("favorite"),
              },
            ]}
            className={cls.root}
            activeBut={{ className: cls.activeBut }}
            but={{ className: cls.but }}
          />
          <CategoryButton category={category} setCategory={setCategory} className={cls.category} />
        </Box>
        <SearchTextField
          variant="outlined"
          placeholder="Search tokens by symbol and name"
          value={searchText}
          event={{
            onChange: (value) => setSearchText(value),
            onClear: () => setSearchText(""),
          }}
          className={cls.search}
        />
      </Box>
      {tokens && <RankingTable tokens={searchTokens} />}
    </PaperWrapper>
  );
}
